export default "__VITE_ASSET__XV3hNjLh__"